<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Business Products",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Business Products",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Business Products",
          active: true,
        },
      ],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsBProductsServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      existingProduct: [],
      nameError: "",
      categoryError: "",

      // Value from user input for adding unit
      data: {
        name: "",
        category: "",
      },
      // edit unit
      editdata: {
        name: "",
        category: "",
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },
      filterBProducts: {
        product: "",
        category: "",
        page: 1,
        per_page: 50,
      },
      mapdata: {
        name: "",
        product: "",
        id: "",
      },
      productError: "",
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("products", [
      "SaveStatus",
      "BProducts",
      "Categories",
      "BProductsPaginated",
      "BProductsPagination",
      "BProducts",
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),

    businessColumns() {
      return [
        { key: "index", label: "S/N" },
        { key: "name", label: "NAME" },
        { key: "category", label: "CATEGORY" },
        { key: "addedBy", label: "ADDED By" },
        { key: "dateAdded", label: "DATE ADDED" },
        { key: "actions", label: "ACTIONS" },
      ];
    },

    rows() {
      return this.IsBProductsServerPaginated
        ? this.BProductsPagination?.total || 0
        : this.BProductsPaginated
        ? this.BProductsPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsBProductsServerPaginated) {
          return (
            (this.BProductsPagination && this.BProductsPagination.per_page) ||
            this.filterBProducts.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsBProductsServerPaginated) {
          this.filterBProducts.per_page = value;
          this.handlePageChange(value);
        }
      },
    },

    currentPage: {
      get() {
        return this.BProductsPaginated && this.BProductsPagination
          ? this.BProductsPagination.current_page
          : 1;
      },
      set(value) {
        if (this.BProductsPaginated && this.BProductsPagination) {
          this.filterBProducts.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchProducts: "products/fetchBProductsData",
      FetchBProductsAction: "products/fetchBProducts",
      FetchCategories: "products/fetchPCategories",
      AddProduct: "products/addBProduct",
      EditProduct: "products/editBProduct",
      DeleteProduct: "products/deleteBProduct",
      MapProductAction: "products/mapBProduct",
    }),

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingProduct = this.BProducts.filter((product) => {
          return product.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingProduct.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingProduct = [];
      }
    },

    addProduct(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Product name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.existingProduct.length) {
        this.nameError = this.data.name + " exists already please";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.category === "") {
        this.categoryError = "Product Category is required";
        return;
      } else {
        this.categoryError = "";
      }

      this.AddProduct(this.data);
      this.FetchProducts(this.filterBProducts);
    },

    resetAdd() {
      this.data.name = "";
      this.data.category = "";
      this.modal_id = "";
    },
    resetEdit() {
      this.editdata.name = "";
      this.editdata.category = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetMap() {
      this.mapdata.name = "";
      this.mapdata.product = "";
      this.mapdata.id = "";
      this.modal_id = "";
      this.productError = "";
    },

    resetError() {
      this.nameError = "";
      this.categoryError = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.name;
      this.editdata.category = data.item.category.catName;
      this.editdata.id = data.item.id;
    },
    editProduct(modalId) {
      this.modal_id = modalId;
      this.EditProduct(this.editdata).then(() => {
        this.FetchProducts(this.filterBProducts);
      });
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.item.id;
    },
    deleteProduct(modalId) {
      this.modal_id = modalId;
      this.DeleteProduct(this.deletedata).then(() => {
        this.FetchProducts(this.filterBProducts);
      });
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        if (modalId === "add-product-modal") this.resetAdd();
        if (modalId === "edit-product-modal") this.resetEdit();
        if (modalId === "delete-product-modal") this.resetDelete();
        if (modalId === "map-product-modal") this.resetMap();
      });
    },

    handleServerSearch() {
      this.filterBProducts.page = 1;
      this.FetchProducts(this.filterBProducts);
    },

    handlePageChange(newPage) {
      if (this.IsBProductsServerPaginated) {
        this.filterBProducts.page = newPage;
        this.FetchProducts(this.filterBProducts);
      }
    },

    showMapModal(data) {
      this.mapdata.name = data.item.name;
      this.mapdata.id = data.item.id;
    },

    mapProduct(modalId) {
      this.modal_id = modalId;
      if (!this.mapdata.product) {
        this.productError = "Please select a business product to map to.";
        return;
      } else {
        this.productError = "";
      }
      this.MapProductAction(this.mapdata);
    },
  },

  created() {
    this.FetchProducts(this.filterBProducts);
    this.FetchCategories();
    this.FetchBProductsAction();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">All Business Products</h4>
              </div>
              <div
                v-if="MyUserPerm && MyUserPerm.add_business_products == 1"
                class="col-md-3"
                align="right"
              >
                <b-button v-b-modal.add-product-modal variant="primary"
                  ><i class="fa fa-plus"></i> Add New</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-3 d-flex align-items-end">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-4 form-group">
                <label>SEARCH BY CATEGORY</label>
                <model-list-select
                  :list="
                    Categories
                      ? [{ id: '', catName: 'All Categories' }, ...Categories]
                      : []
                  "
                  v-model="filterBProducts.category"
                  option-value="id"
                  option-text="catName"
                  placeholder="Select Category"
                  @input="handleServerSearch()"
                >
                </model-list-select>
              </div>
              <div class="col-sm-12 col-md-5">
                <label>SEARCH PRODUCT</label>
                <div class="input-group">
                  <b-form-input
                    v-model="filterBProducts.product"
                    type="search"
                    placeholder="Search by product name..."
                    class="form-control form-control-sm"
                    @keyup.enter="handleServerSearch()"
                  ></b-form-input>
                  <div class="input-group-append">
                    <button
                      class="btn btn-primary"
                      type="button"
                      @click="handleServerSearch()"
                    >
                      <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Searching"
                      ></b-spinner>
                      <span>Search</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0 mt-3">
              <DataTable
                :columns="businessColumns"
                :rows="BProductsPaginated || []"
                :total-rows="rows"
                :pagination="BProductsPagination"
                :server-pagination="IsBProductsServerPaginated"
                :loading="SaveStatus"
              >
                <!-- index column -->
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>

                <!-- name -->
                <template #cell(name)="{ row }">
                  {{ row.name }}
                </template>

                <!-- category -->
                <template #cell(category)="{ row }">
                  {{ row.category?.catName || "N/A" }}
                </template>

                <!-- added by -->
                <template #cell(addedBy)="{ row }">
                  {{ row.user?.name || "N/A" }}
                </template>

                <!-- date -->
                <template #cell(dateAdded)="{ row }">
                  {{ row.added_on }}
                </template>

                <!-- action buttons -->
                <template #cell(actions)="{ row }">
                  <b-button-group>
                    <b-button
                      v-if="
                        MyUserPerm && MyUserPerm.edit_business_products == 1
                      "
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-product-modal
                      @click="showEditModal({ item: row })"
                    >
                      <i class="fa fa-edit"></i> Edit
                    </b-button>
                    <b-button
                      v-if="
                        MyUserPerm && MyUserPerm.delete_business_products == 1
                      "
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-product-modal
                      @click="showDeleteModal({ item: row })"
                    >
                      <i class="fa fa-trash"></i> Delete
                    </b-button>
                    <b-button
                      v-if="
                        MyUserPerm && MyUserPerm.edit_business_products == 1
                      "
                      size="sm"
                      variant="success"
                      v-b-modal.map-product-modal
                      @click="showMapModal({ item: row })"
                      ><i class="fa fa-pencil-alt"></i> Map</b-button
                    >
                  </b-button-group>
                </template>
              </DataTable>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal id="add-product-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add New Global Product </template>
      <div class="form-group mb-3">
        <label>Product Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Product Name"
            class="form-control"
            @keyup="checkName"
            @input="resetError()"
            v-model="data.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Product Category <span class="text-danger">*</span></label>
        <input
          class="form-control"
          v-model="data.category"
          list="categories"
          placeholder="Enter Product Category"
          autocomplete="off"
        />
        <datalist id="categories">
          <option
            v-for="(cat, c) in Categories"
            :data-value="cat.catName"
            :key="c"
          >
            {{ cat.catName }}
          </option>
        </datalist>
        <div class="text-danger" v-if="categoryError">
          <em>{{ categoryError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addProduct('add-product-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- edit modal starts -->
    <b-modal id="edit-product-modal" hide-footer @hidden="resetEdit">
      <template #modal-title> Edit Product {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Product Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            @input="resetError()"
            v-model="editdata.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Product Category <span class="text-danger">*</span></label>
        <input
          class="form-control"
          v-model="editdata.category"
          list="categories"
          placeholder="Enter Product Category"
          autocomplete="off"
        />
        <datalist id="categories">
          <option
            v-for="(cat, c) in Categories"
            :data-value="cat.catName"
            :key="c"
          >
            {{ cat.catName }}
          </option>
        </datalist>
        <div class="text-danger" v-if="categoryError">
          <em>{{ categoryError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editProduct('edit-product-modal')"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-product-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title> Delete Product {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this Product? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteProduct('delete-product-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal map product starts -->
    <b-modal id="map-product-modal" hide-footer @hidden="resetMap">
      <template #modal-title> Map Business product {{ mapdata.name }}</template>
      <div class="form-group mb-3">
        <label
          >Map into Business product <span class="text-danger">*</span></label
        >
        <div class="input-group">
          <model-list-select
            :list="BProducts ? BProducts : []"
            v-model="mapdata.product"
            option-value="id"
            option-text="name"
            class="mb-3"
            placeholder="Select Business Product to Map Into"
            @input="productError = ''"
          >
          </model-list-select>
        </div>
        <div class="text-danger" v-if="productError">
          <em>{{ productError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('map-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="mapProduct('map-product-modal')"
          :disabled="SaveStatus"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
